import ChibiTeamService from '@/services/ChibiTeamService'

/** Shared Chibi contact dropdown data from GET /api/chibi_team (DB-backed). */
export default {
  data() {
    return {
      chibiTeam: [],
      chibiTeamNames: []
    }
  },
  created() {
    this.loadChibiTeam()
  },
  methods: {
    async loadChibiTeam() {
      const members = await ChibiTeamService.list()
      this.chibiTeam = members
      this.chibiTeamNames = ChibiTeamService.namesFrom(members)
    },
    myChibiName() {
      const keys = [
        this.username,
        typeof localStorage !== 'undefined' ? localStorage.getItem('username') : '',
        typeof localStorage !== 'undefined' ? localStorage.getItem('gmail_email') : ''
      ].flatMap((s) => {
        const v = (s || '').toString().toLowerCase().trim()
        if (!v) return []
        return [v, v.split('@')[0]]
      })
      const match = (this.chibiTeam || []).find((m) => {
        const email = (m.email || '').toLowerCase()
        const local = email.split('@')[0]
        const name = (m.name || '').toLowerCase()
        return keys.includes(email) || keys.includes(local) || keys.includes(name)
      })
      return match ? match.name : null
    },
    wishTaggedList(w) {
      return Array.isArray(w && w.tagged_members) ? w.tagged_members.filter(Boolean) : []
    },
    wishIsMine(w) {
      const email = (this.username || '').toString().toLowerCase().trim()
      const name = this.myChibiName()
      if (email && (w.author_email || '').toString().toLowerCase().trim() === email) return true
      const assignee = (w.assigned_to || '').toString().trim()
      if (name && assignee && assignee.toLowerCase() === name.toLowerCase()) return true
      if (name && this.wishTaggedList(w).some((n) => n.toLowerCase() === name.toLowerCase())) return true
      return false
    }
  }
}
